"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M16.827 1a.38.38 0 0 1 .235.082l5.793 4.631a.39.39 0 0 1 .083.515l-10.62 16.596a.378.378 0 0 1-.636 0L1.062 6.228a.39.39 0 0 1 .083-.515l5.793-4.631A.379.379 0 0 1 7.173 1h9.654Zm-.895 5.749H8.067L12 21.345l3.932-14.596Zm5.835 0h-5.052L13.01 20.497l8.757-13.748Zm-14.483 0H2.232l8.754 13.743L7.284 6.749ZM9.54 1.916H7.318L2.544 5.75h4.554l.015-.032L9.54 1.916Zm4.019 0H10.44L7.99 5.749h8.019l-2.45-3.833Zm3.123 0h-2.223l2.41 3.771.031.062h4.555l-4.773-3.832Z",
    clipRule: "evenodd"
  })]
});